import axios from "axios";
import { QUESTIONNAIRE_API } from "../../../config/microserviceApis";
import { createLog } from "./logs/logs";

export const verificationAxios = axios.create();

verificationAxios.interceptors.request.use(
    (config) => {
        if (!config.baseURL) {
            let url = QUESTIONNAIRE_API;
            if (url) {
                config.baseURL = url;
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export async function apiGetQuestionnaireFormSetting(id) {
    const lang = localStorage.getItem('language');

    try {
        const response = await verificationAxios.get(`/api/form/setting/${id}?language=${lang}`);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetQuestionnaireRecordStatus(id) {

    try {
        const response = await verificationAxios.get(`/api/form/records/${id}/submitted`);
        return response?.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetQuestionnaireRecordInit(payload) {

    try {
        const response = await verificationAxios.post(`/api/form/records/init`, payload);
        createLog({
            module: "Verification", submodule: "Questionnaire", function: "initRecord",
            description: "Questionnaire record initialized",
            logData: { payload },
        });
        return response?.data;
    } catch (e) {
        createLog({
            module: "Verification", submodule: "Questionnaire", function: "initRecord",
            description: "Failed to initialize questionnaire record",
            status: "error",
            logData: { payload, error: e?.message },
        });
        console.error(e);
        throw e;
    }
}